import { normalizeAuthTokens } from "@/schemas/auth";
import type { AuthTokens } from "@/types";

let authTokens: AuthTokens | null = null;

export function setInMemoryAuthTokens(value: unknown): AuthTokens | null {
  const normalized = normalizeAuthTokens(value);
  if (!normalized) {
    authTokens = null;
    return null;
  }

  authTokens = {
    ...normalized,
    refreshToken: "",
  };
  return authTokens;
}

export function getInMemoryAuthTokens(): AuthTokens | null {
  return authTokens;
}

export function clearInMemoryAuthTokens(): void {
  authTokens = null;
}
